import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';
import { createActionResponseFactory } from '@core/ngrx-legacy';
// eslint-disable-next-line boundaries/element-types
import { TellentGroupsActions, TellentGroupsSelectors } from '@core/tellent-data'; // FIXME

import { GROUP_KIND } from '../edit-member-admin-dialog/edit-member-groups-tab/edit-member-group-tab.controller';

@Injectable()
export class SelectGroupsService {
  private readonly kind = inject(GROUP_KIND);
  private readonly store = inject(Store);
  private readonly actionResponse = createActionResponseFactory(TellentGroupsActions);

  public readonly selectGroupsPagination = this.store.selectSignal(
    TellentGroupsSelectors.pagination({ scope: this.kind }),
  );

  public fetchAndSelectWithPageAndQuery(page: number, query: string, limit: number) {
    return this.actionResponse(
      TellentGroupsActions.fetchPaginatedCollection,
      {
        payload: {
          params: {
            query,
            page,
            limit,
            scope: this.kind,
          },
        },
      },
      {
        successResponse: () =>
          this.store.select(TellentGroupsSelectors.entities({ scope: this.kind })),
      },
    ).pipe(
      map(({ success }) => success),
      filterBoolean,
    );
  }
}
